import apiClient from './apiClient';

export interface AuditTrailItem {
  id: string;
  action: string;
  entityType: string;
  entityId: string | null;
  projectId: string | null;
  taskId: string | null;
  actorUserId: string | null;
  actorName: string | null;
  actorRole: string | null;
  fromState: string | null;
  toState: string | null;
  reasonCode: string | null;
  notes: string | null;
  metadata: Record<string, any> | null;
  occurredAt: string;
}

class AuditLogService {
  async list(params: { projectId?: string; entityType?: string; search?: string; limit?: number } = {}): Promise<AuditTrailItem[]> {
    const response: any = await apiClient.get('/audit-log', { params });
    return response.data;
  }
}

export default new AuditLogService();
